// Define the search criteria for custom service resources
export const SLUG_PREFIX = 'c__';
export const ALLOWED_ACTIONS_COUNT = 11;
